export default "__VITE_ASSET__2MmgkxLL__"